/* eslint-disable */
export default {
  save: '儲存',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
